/**
 * Lead Generation Module Routes
 *
 * Route definitions with lazy-loaded components. Titles, descriptions, and
 * breadcrumbs are resolved automatically by the i18n router guard based on
 * each route's `name` — see `src/plugins/i18n/routeI18n.ts` for the mapping.
 */
import type { RouteRecordRaw } from 'vue-router'
import type { Role } from '../../src/types'

const roles: Role[] = ['ai_lab_admin', 'mandant_admin']

const routes: RouteRecordRaw[] = [
  {
    path: '/tenant/lead-generation',
    name: 'leadgen.section',
    meta: { requiresAuth: true, roles },
    children: [
      {
        path: '',
        name: 'leadgen.overview',
        component: () => import('./pages/LeadGenerationOverview.vue'),
        meta: { requiresAuth: true, roles }
      },
      {
        path: 'settings',
        name: 'leadgen.settings',
        component: () => import('./pages/LeadGenerationSettings.vue'),
        meta: { requiresAuth: true, roles }
      },
      {
        path: 'privacy-settings',
        name: 'leadgen.privacySettings',
        component: () => import('./pages/LeadGenerationPrivacySettings.vue'),
        meta: { requiresAuth: true, roles }
      },
      {
        path: 'mail-template',
        name: 'leadgen.mailTemplate',
        component: () => import('./pages/MailTemplateEditor.vue'),
        meta: { requiresAuth: true, roles }
      }
    ]
  }
]

export default routes
